import type { Action, BudgetActionsState, PreviousActions } from '../types'

import { defineStore } from 'pinia'

import { actionSelectTabs } from '../constants'

export const useBudgetActionsStore = defineStore('budgetActions', {
  state: (): BudgetActionsState => ({
    initialized: false,
    previousActions: { all: { action: null, children: [] } },
    lastActionRowIds: [],
    openTab: actionSelectTabs.MANUAL,
  }),
  getters: {
    getChildrenForElementIds: (
      state: BudgetActionsState
    ): Record<string, string[]> => {
      return Object.keys(state.previousActions).reduce(
        (elementIds, elementId): Record<string, string[]> => {
          elementIds[elementId] = state.previousActions[elementId].children
          return elementIds
        },
        {} as Record<string, string[]>
      )
    },
  },
  actions: {
    initialize({
      tableStructure,
      seededLastAction,
    }: {
      tableStructure: Record<string, string[]>
      seededLastAction: Action | null
    }): void {
      this.openTab = actionSelectTabs.MANUAL

      const previousActions: PreviousActions = {
        all: { action: seededLastAction, children: [] as string[] },
      }

      Object.entries(tableStructure).forEach(([id, children]) => {
        previousActions[id] = { action: seededLastAction, children }
        previousActions['all'].children.push(id)
      })

      this.previousActions = previousActions
    },

    setOpenTab(selectedTab: string): void {
      this.openTab = selectedTab
    },

    setPreviousAction(
      elementId: string,
      action: Action | null,
      childActions?: Record<string, Action>
    ): void {
      this.previousActions[elementId].action = action

      // Remove the previous action from children
      const children = this.previousActions[elementId].children

      children.forEach((childId) => {
        const childAction = childActions?.[childId] ?? null

        this.setPreviousAction(childId, childAction, childActions)
      })

      // Set lastActionRowIds for the affected rows
      this.lastActionRowIds = [elementId].concat(children)
    },

    setLastActionRowIds(lastActionRowIds: string[]): void {
      this.lastActionRowIds = lastActionRowIds
    },
  },
})
